var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 883"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 924",
    x: 12,
    y: 11,
    width: 14,
    height: 14,
    rx: 7,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 17",
    d: "M27 11.0805L18.4909 4V8.18391H14V14.4598H18.4909V18L27 11.0805Z",
    fill: "#007C20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 18",
    d: "M3 19.0805L11.5091 12V16.1839H16V22.4598H11.5091V26L3 19.0805Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapDark);
export default __webpack_public_path__ + "static/media/swap_dark.a92a7b326e009bf18b348483e2810a3b.svg";
export { ForwardRef as ReactComponent };